import styled from "styled-components";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import { colors, TextLink, typography } from "design-system";

import { largeScreen, smallScreen } from "src/shared/constants/screenSizes";

export const Info = styled.div`
  background-color: ${colors.NOTICE_LIGHTEST};
  display: flex;
  flex-direction: row;
  padding: 8px;
  text-align: left;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 10px;
    margin: 4px;
  }
`;

export const Icon = styled(FontAwesomeIcon).attrs({
  desktopPadding: "0px 8px",
  fontSize: "16px",
  iconClass: "info-circle",
  mobilePadding: "0px 10px 0px 0px"
})`
  color: ${colors.TEXT_SECONDARY};
  line-height: 22px;
`;

export const TextLinkButton = styled(TextLink).attrs({
  href: "#",
  typography: "caps",
  underlined: false
})`
  color: ${colors.BRAND_DARK};
  display: inline-block;
`;

export const Body = styled(typography.P)`
  @media screen and (max-width: ${largeScreen}px) {
    font-size: 14px;
    line-height: 22px;
  }
`;
